"use client";

import { useState } from "react";
import { useToast } from "./Toast";

export default function PitchGenerator() {
  const [loading, setLoading] = useState(false);
  const [pitch, setPitch] = useState("");
  const [prompt, setPrompt] = useState("");
  const [tone, setTone] = useState("Persuasivo");
  const [audience, setAudience] = useState("WhatsApp");
  const [validationError, setValidationError] = useState("");
  const { addToast } = useToast();

  const validateForm = () => {
    if (!prompt.trim()) {
      setValidationError("Por favor, digite o contexto para o pitch.");
      return false;
    }
    if (prompt.trim().length < 10) {
      setValidationError("O contexto deve ter pelo menos 10 caracteres.");
      return false;
    }
    setValidationError("");
    return true;
  };

  const handleGenerate = async () => {
    if (!validateForm()) return;
    
    setLoading(true);
    setPitch("");
    try {
      const response = await fetch("/api/generate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prompt, tone, audience }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Falha ao gerar o pitch");
      }

      setPitch(data.text);
    } catch (error: any) {
      console.error(error);
      setPitch(error.message || "Falha ao gerar o pitch. Por favor, tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-secondary p-8 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4">Gerador de Pitch (Gemini)</h2>
      <div className="flex flex-col gap-4">
        <textarea
          placeholder="Digite o contexto para o pitch..."
          className={`bg-primary text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent h-32 ${
            validationError ? "border-2 border-red-500" : ""
          }`}
          value={prompt}
          onChange={(e) => {
            setPrompt(e.target.value);
            setValidationError("");
          }}
        ></textarea>
        <div className="grid grid-cols-2 gap-4">
          <select
            className="bg-primary text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
            value={tone}
            onChange={(e) => setTone(e.target.value)}
          >
            <option>Selecione o Tom</option>
            <option>Formal</option>
            <option>Informal</option>
            <option>Persuasivo</option>
            <option>Urgente</option>
          </select>
          <select
            className="bg-primary text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
            value={audience}
            onChange={(e) => setAudience(e.target.value)}
          >
            <option>Público Alvo</option>
            <option>WhatsApp</option>
            <option>Telegram</option>
            <option>Geral</option>
          </select>
        </div>
        {validationError && (
          <p className="text-red-500 text-sm">{validationError}</p>
        )}
        <button
          className="bg-accent hover:bg-purple-700 text-white font-bold py-3 px-4 rounded transition-transform transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleGenerate}
          disabled={loading || !prompt.trim()}
        >
          {loading ? "Gerando..." : "Gerar Pitch"}
        </button>
        <div className="mt-8 bg-primary rounded-lg p-4 min-h-64 flex items-center justify-center">
          {loading && (
            <div className="flex flex-col items-center">
              <div className="spinner"></div>
              <p className="mt-4 text-gray-400">Gerando pitch...</p>
            </div>
          )}
          {pitch && (
            <div className="relative w-full">
              <p className="text-white whitespace-pre-wrap">{pitch}</p>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(pitch);
                  addToast("Pitch copiado para a área de transferência!", "success");
                }}
                className="absolute top-0 right-0 bg-accent hover:bg-purple-700 text-white p-2 rounded-lg transition-colors"
                title="Copiar pitch"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </button>
            </div>
          )}
          {!loading && !pitch && (
            <p className="text-gray-400">O pitch gerado aparecerá aqui</p>
          )}
        </div>
      </div>
    </div>
  );
}
